// extracted by mini-css-extract-plugin
export var dividerContainer = "_5c-0";
export var line = "_5c-1";